export const selectModalVisibility = (state) =>
  state.pictureExpandModalReducer.get('modalVisible', false);
export const selectPictureUrl = (state) =>
  state.pictureExpandModalReducer.get('pictureUrl', '');
